import { numberFormatter } from "./number-formatter";

export function odometerFormatter(input: string): string {
  const value = numberFormatter(input);

  if (typeof value !== "number" || isNaN(value)) {
    return "";
  }

  const numbers = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);

  return `${numbers} Km`;
}
